<template>
  <ValidationProvider :name="fieldName" :vid="metaName" :rules="validRules" v-slot="{ classes, errors }">
    <span v-tooltip.bottom="{
            content: errors[0],
            trigger: 'hover',
            show: errors[0],
          }">
      <span class="valid-wrap" :class="classes">
        <slot></slot>
      </span>
    </span>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider, extend, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'

// デフォルトのルールとエラーメッセージを読み込む
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: ja.messages[rule]
  });
});
// パスワード強度チェック
extend('pass_strength', value => {
  const zxcvbn = require('zxcvbn');
  if (2 < zxcvbn(value).score) {
    return true;
  }
  return 'パスワードの強度が不足しています';
})
// メールアドレスや名前をパスワードにしない
extend('pass_is_not_id', {
  params: ['mail', 'user_name'],
  validate(value, {mail, user_name}) {
    return value !== mail && value !== user_name;
  },
  message: 'メールアドレスや氏名をパスワードにすることはできません'
})
// 登録済み工事名を除外する
extend('exists_construction_excluded', {
  ...rules.excluded,
  message: '既に登録されている工事名は使用できません'
})
// エラー時のclassとか
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

import Vue from 'vue'
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

export default {
  name: 'ValidationInput',
  components: {
    ValidationProvider
  },
  props: {
    'validRules': Object,
    'fieldName': String,
    'metaName': String,
  },
}
</script>

<style scoped>
@keyframes invalidBlink {
  50% {
    box-shadow: 0 0 5px crimson
  }
}
.is-invalid >>> input {
  box-shadow: 0 0 3px crimson;
  animation: invalidBlink .7s step-end infinite alternate;
}
</style>
<style>
.tooltip {
  display: block !important;
  z-index: 10000;
}
.tooltip .tooltip-inner {
  background: crimson;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: crimson;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>